<template>
  <v-container class="comissoes-permanentes">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <PageTitle
        icon="mdi-pencil-box-outline"
        main="Gestão"
        sub="Conselhos, Comissões e Diretorias do Legislativo"
        home='/gestao-admin'
      />
      <div>
        <formulario />
      </div>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Formulario from '../components/comissoes/index.vue'
export default {
  name: 'ComissoesPermanentes',
  components: { PageTitle, Formulario },
  data: () => ({
  })
}
</script>

<style scoped>
</style>
